import React from 'react';

// Glowing galaxy emblem used across the app
export function GalaxyMark({ size = 96, glow = true }) {
  return (
    <div className={glow ? 'glow-purple' : ''} style={{
      width: size, height: size, borderRadius: size * 0.32,
      background: 'radial-gradient(circle at 50% 45%, #2a2b57 0%, #14152f 70%, #0c0d22 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      border: '1px solid rgba(139,124,232,.4)',
    }}>
      <svg width={size * 0.78} height={size * 0.78} viewBox="0 0 100 100" fill="none">
        <defs>
          <radialGradient id="core" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="60%" stopColor="#c7d6ff" />
            <stop offset="100%" stopColor="#6c5fbf" stopOpacity="0" />
          </radialGradient>
        </defs>
        <ellipse cx="50" cy="50" rx="40" ry="15" stroke="#7fb0ff" strokeWidth="1.6" transform="rotate(-22 50 50)" opacity="0.9" />
        <ellipse cx="50" cy="50" rx="32" ry="11" stroke="#57d8e6" strokeWidth="1.4" transform="rotate(-22 50 50)" opacity="0.8" />
        <ellipse cx="50" cy="50" rx="46" ry="18" stroke="#b7a5ff" strokeWidth="1" transform="rotate(-22 50 50)" opacity="0.5" />
        <circle cx="50" cy="50" r="11" fill="url(#core)" />
        <circle cx="27" cy="41" r="2.4" fill="#dfe7ff" />
        <circle cx="33" cy="33" r="1.8" fill="#bcd0ff" />
        <circle cx="74" cy="58" r="2" fill="#cfe0ff" />
      </svg>
    </div>
  );
}

// "Orbit" wordmark with a glowing ring for the O
export function OrbitWordmark({ size = 40 }) {
  return (
    <div className="flex items-center" style={{ gap: size * 0.02 }}>
      <span style={{
        width: size * 1.05, height: size * 1.05, borderRadius: '50%',
        border: `${Math.max(2, size * 0.07)}px solid #d9c9ff`,
        boxShadow: '0 0 18px 4px rgba(170,140,255,.9), inset 0 0 10px rgba(170,140,255,.6)',
        display: 'inline-block',
      }} />
      <span className="font-display text-glow-purple" style={{
        fontSize: size, fontWeight: 600, color: '#efe9ff', marginLeft: -size * 0.18, letterSpacing: '.5px',
      }}>rbit</span>
    </div>
  );
}
